import axios from 'axios';
import { handleExpiredAuthSession } from '../utils/authSessionCleanup';

const rawBaseUrl = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000';
const API_BASE_URL = rawBaseUrl;

const authClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: Inject token from localStorage
authClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: Handle 401 & refresh logic
authClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = Number(error?.response?.status || 0);
    const detail = error?.response?.data?.detail;
    const detailCode = typeof detail === 'object' ? String(detail?.code || '').toUpperCase() : '';
    if (status === 401) {
      handleExpiredAuthSession(detailCode || null);
    }
    return Promise.reject(error);
  }
);

export default authClient;
